import { useContext, useEffect } from 'react';

import {
  ContextBarContext,
  ContextBarPageTransition,
} from 'src/context/contextBarContext';

/**
 * Hook for components to use the context bar.
 * @param transitionObj - The transition object to set the context bar to. If not provided, the context bar will not be transitioned.
 * @returns The context bar context value.
 */
export const useContextBar = (transitionObj?: ContextBarPageTransition) => {
  const contextBarContextValue = useContext(ContextBarContext);

  const { transition } = contextBarContextValue;
  const targetId = transitionObj?.target?.id;
  const targetEntityType = transitionObj?.target?.entityType;
  const open = transitionObj?.open;

  useEffect(() => {
    if (targetId && targetEntityType) {
      transition({
        target: { id: targetId, entityType: targetEntityType },
        // need to recreate drawerConfig to avoid infinite rerenders
        drawerConfig: {
          INTERNAL_CHAT: transitionObj.drawerConfig?.INTERNAL_CHAT,
          NOTES: transitionObj.drawerConfig?.NOTES,
          DETAILS: transitionObj.drawerConfig?.DETAILS,
        },
        open,
      });
    }
  }, [
    targetId,
    targetEntityType,
    open,
    transitionObj?.drawerConfig?.INTERNAL_CHAT,
    transitionObj?.drawerConfig?.NOTES,
    transitionObj?.drawerConfig?.DETAILS,
    transition,
  ]);

  return contextBarContextValue;
};
